import { RouteConfig } from 'vue-router';
import { ReleaseUpdatesRoute } from '@/modules/resourcecenter/constants/ReleaseUpdatesRoute';

export const router: RouteConfig[] = [
  {
    path: `/resource-center`,
    name: 'resource-center',
    component: () => import('@/modules/resourcecenter/pages/ResourceCenterPage.vue')
  },
  {
    path: `/${ReleaseUpdatesRoute.RELEASE_UPDATES}`,
    name: ReleaseUpdatesRoute.RELEASE_UPDATES,
    component: () => import('@/modules/resourcecenter/pages/ReleaseUpdatesPage.vue')
  }
];
